
import type { PropType } from 'vue'
import { computed, defineComponent, ref } from 'vue'
import { EpbButton } from '../epb-button'
import { EpbText } from '../epb-text'
import EpbModal from './epb-modal.component.vue'

export enum ModalTypeeEnum {
  WARNING = 'warning',
  INFO = 'info',
  ERROR = 'error',
}

export default defineComponent({
  name: 'EpbConfirmModal',
  components: { EpbModal, EpbText, EpbButton },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: [String, undefined],
      default: undefined,
    },
    messages: {
      type: Object as PropType<{
        actions: {
          confirm: string
          cancel: string
        }
      }>,
      required: true,
    },
    type: {
      type: String as PropType<ModalTypeeEnum>,
      default: undefined,
    },
    width: {
      type: String,
      default: '528px',
    },
    closable: {
      type: Boolean,
      default: true,
    },
  },
  emits: {
    close: () => {},
    confirm: () => {},
  },
  setup(props, { emit }) {
    const modalRef = ref(null)

    const icon = computed<string>(
      () =>
        ({
          [ModalTypeeEnum.WARNING]: 'warning',
          [ModalTypeeEnum.INFO]: 'infocircular',
          [ModalTypeeEnum.ERROR]: 'errorcircular',
        })[props.type],
    )

    function onClose() {
      modalRef.value?.close()
    }

    function onConfirm() {
      emit('confirm')
      onClose()
    }

    return {
      baseClass: 'epb-confirm-modal',
      modalRef,
      icon,
      onClose,
      onConfirm,
    }
  },
})
